import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import withPermissionCheck from '../../core/access-control/with-permission-check'
import { Permission } from '../../core/auth0'

import RootState from '../../core/root-state'
import Layout from '../layouts/layout'
import Wrapper from '../layouts/wrapper'
import { MachineError, machineErrorsActions } from '../../core/machine-errors'
import { strings } from '../components/machine-errors/machine-errors-content'
import styles from '../styles/modules/machine-errors/machine-errors.module.scss'
import MachineErrorsTable from '../components/machine-errors/machine-errors-item'
import Pagination from '../components/pagination/pagination'

interface Props {
  machineErrors: MachineError[]
  isLoading: boolean
  totalCount: number
  currentPage: number
  pageSize: number
  fetchMachineErrors: (limit?: number, offset?: number) => void
  setCurrentPage: (page: number) => void
}

class MachineErrorsScreen extends React.Component<Props, {}> {
  componentDidMount = () => {
    this.props.fetchMachineErrors()
  }

  handlePageChange = (page: number) => {
    this.props.setCurrentPage(page)
    const offset = (page - 1) * this.props.pageSize
    this.props.fetchMachineErrors(this.props.pageSize, offset)
  }

  render() {
    return (
      <Layout location={'machine_errors'}>
        <Wrapper title={strings.title}>
          <div className={styles.container}>
            <MachineErrorsTable machineErrors={this.props.machineErrors} />
            <Pagination
              currentPage={this.props.currentPage}
              totalCount={this.props.totalCount}
              pageSize={this.props.pageSize}
              onPageChange={this.handlePageChange}
            />
          </div>
        </Wrapper>
      </Layout>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  machineErrors: state.machineErrors.machineErrors,
  isLoading: state.machineErrors.isLoading,
  totalCount: state.machineErrors.totalCount,
  currentPage: state.machineErrors.currentPage,
  pageSize: state.machineErrors.pageSize,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchMachineErrors: (limit?: number, offset?: number) =>
    dispatch(machineErrorsActions.fetchMachineErrors(limit, offset)),
  setCurrentPage: (page: number) =>
    dispatch(machineErrorsActions.setCurrentPage(page)),
})

const ConnectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(MachineErrorsScreen)

export default withPermissionCheck(ConnectedComponent, {
  requiredPermission: Permission.MACHINE_ERROR_HISTORY_READ,
  redirectTo: '/404',
})
